import { mdiShieldAlertOutline } from "@mdi/js";
import _DatabaseModel from "./_DatabaseModel";

class ThreatCategory extends _DatabaseModel {
  static model = "threat_category";
  static editDialogComponent = "threat-category-edit-dialog";

  static tableHeaders = [
    { textKey: "form.label.id", value: "id", sortable: false },
    { textKey: "form.label.name", value: "name" },
    {
      textKey: "other.actions",
      value: "actions",
      sortable: false,
      align: "right",
      cellClass: "text-no-wrap",
    },
  ];

  static filter = {
    parts: {
      fields: ["name", "time_filter"],
      extended_fields: [],
      time_filter: ["created_at", "updated_at"],
    },
  };

  static operations = ["export"];

  static cardFields(object) {
    return {
      title: object.name,
      actions: ["edit", "delete"],
      src: {
        cardIcon: mdiShieldAlertOutline,
        color: object.color,
      },
    };
  }
}

export default ThreatCategory;
